import { CardData } from './card-data';
import { memoize } from '../../modules/shared/decorators/memoize';
import { StrainType } from '../enum/dto/strain-classification.enum';

export class TheWoodsCardData extends CardData {
  public colorStripWidth(): string {
    return '3rem';
  }

  public hasCraftDesignation(): boolean {
    return this.rowVariants?.some(variant => variant?.hasCraftDesignation());
  }

  private readonly allowedStrainTypes = [
    StrainType.Sativa,
    StrainType.SativaDominant,
    StrainType.Indica,
    StrainType.IndicaDominant,
    StrainType.Hybrid,
    StrainType.Blend
  ];

  /**
   * Note that getReadableStrainType calls:
   *
   *   return StrainTypeUtils.getStandardizedName(strainType, this.menu?.shouldStandardizeDominantStrainType());
   *
   * Where shouldStandardizeDominantStrainType defaults to true, so Indica Dominant and Sativa Dominant are converted
   * to say Indica and Sativa when `getReadableStrainType` is called
   */
  @memoize
  override getStrainType(): StrainType {
    const strainType = super.getStrainType();
    if (this.allowedStrainTypes?.includes(strainType)) {
      return strainType;
    }
    return StrainType.UNKNOWN;
  }

  @memoize
  override getStrainTypeColor(): string {
    switch (this.getStrainType()) {
      case StrainType.Indica:
      case StrainType.IndicaDominant:
        return '#353C4D';
      case StrainType.Sativa:
      case StrainType.SativaDominant:
        return '#E4BA38';
      case StrainType.Blend:
        return '#427266';
      case StrainType.Hybrid:
        return '#D3C09B';
      case StrainType.UNKNOWN:
        return '#1B322B';
      default:
        return '#1B322B';
    }
  }
}
